module.exports = __webpack_public_path__ + "f38f6b319337b540d7baad4d51a59a83.MP3";